import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll to the top whenever the pathname changes,
 * EXCEPT when the URL contains a hash (in that case `useScrollToHash`
 * on the destination page handles scrolling to the anchor).
 *
 * Mounted once at the top of <App /> so it covers every route.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
}
